// removed by extract-text-webpack-plugin
module.exports = {"section":"_18f23e50","titles":"_9e766f3e","title":"_9fad2c08","subtitle":"_0113fe21"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/EirVisitTypeHeaderTopSection/index.styl
// module id = 4963
// module chunks = 39